"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultistreamContext = exports.VideoClientContext = exports.RecorderUiContext = exports.PlayerUiContext = exports.CallContext = exports.EncoderUiContext = void 0;
const react_1 = require("react");
const EncoderUiContext = (0, react_1.createContext)(null);
exports.EncoderUiContext = EncoderUiContext;
const PlayerUiContext = (0, react_1.createContext)(null);
exports.PlayerUiContext = PlayerUiContext;
const RecorderUiContext = (0, react_1.createContext)(null);
exports.RecorderUiContext = RecorderUiContext;
const VideoClientContext = (0, react_1.createContext)(null);
exports.VideoClientContext = VideoClientContext;
const CallContext = (0, react_1.createContext)(null);
exports.CallContext = CallContext;
const MultistreamContext = (0, react_1.createContext)(null);
exports.MultistreamContext = MultistreamContext;
//# sourceMappingURL=Context.js.map